module.exports = __webpack_public_path__ + "img/Stripe_logo,_revised_2016.fb4644a0.png";